import { render, staticRenderFns } from "./RepxMessageDetail.vue?vue&type=template&id=709773e3"
import script from "./RepxMessageDetail.vue?vue&type=script&lang=js"
export * from "./RepxMessageDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('709773e3')) {
      api.createRecord('709773e3', component.options)
    } else {
      api.reload('709773e3', component.options)
    }
    module.hot.accept("./RepxMessageDetail.vue?vue&type=template&id=709773e3", function () {
      api.rerender('709773e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/repx/RepxMessageDetail.vue"
export default component.exports